module.exports = __webpack_public_path__ + "static/media/logo.fccf3e00.png";